import type { ReactNode } from 'react'
import Footer from '@/components/Footer'
import MobileColonyDock from '@/components/MobileColonyDock'
import Navbar from '@/components/Navbar'
import RugScanAd from '@/components/RugScanAd'
import TrendingTicker from '@/components/TrendingTicker'
import { useOnChainListings } from '@/hooks/useOnChainListings'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  useOnChainListings()
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden bg-black pb-24 text-zinc-300 md:pb-0">
      <div
        className="pointer-events-none absolute inset-x-0 top-0 h-[520px] bg-[radial-gradient(ellipse_at_top,rgba(163,230,53,0.14),transparent_58%)]"
        aria-hidden="true"
      />
      <div className="pp-grid pointer-events-none absolute inset-x-0 top-0 h-[640px] opacity-70" aria-hidden="true" />
      <div className="sticky top-0 z-50">
        <Navbar />
        <TrendingTicker />
      </div>
      <main className="relative z-10 flex-1">
        {children}
      </main>
      <RugScanAd />
      <Footer />
      <MobileColonyDock />
    </div>
  )
}

export default Layout
